<template>
  <Transition name="fade-scale">
    <button
      ref="ui-fab"
      class="ui-fab fixed right-15 bottom-15 flex items-center uppercase shadow-6dp cursor-pointer overflow-hidden
      focus:outline-none hover:shadow-12dp mobile-m:right-20 mobile-m:bottom-20
      tablet:right-30 tablet:bottom-30"
      :class="{
        'p-14 rounded-full': !labelIsVisible,
        'py-12 px-25 rounded-24 tablet:rounded-20': labelIsVisible,
      }"
      v-on="$listeners"
    >
      <slot name="icon" />
      <TransitionCollapse direction="horizontal">
        <span
          v-show="labelIsVisible"
          class="font-medium text-sm tracking-wide whitespace-no-wrap tablet:block"
        >
          <span class="ml-15">
            <slot />
          </span>
        </span>
      </TransitionCollapse>
    </button>
  </Transition>
</template>

<script>
import TransitionCollapse from '@/components/transition/TransitionCollapse';

export default {
  props: {
    labelIsVisible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TransitionCollapse,
  },
};
</script>

<style scoped>
.ui-fab {
  transition: all 0.3s ease;
}
</style>
